import React from 'react';
import { useSelector } from 'react-redux';
import { Redirect, useLocation } from 'react-router-dom';

/**
 * Login gate component. Checks Volto's Redux userSession state.
 * If no token → redirects to /login with return_url.
 * If token exists → renders children.
 */
const RequireLogin = ({ children }) => {
  const token = useSelector((state) => state.userSession?.token);
  const location = useLocation();

  if (!token) {
    return (
      <Redirect
        to={`/login?return_url=${encodeURIComponent(location.pathname)}`}
      />
    );
  }

  return <>{children}</>;
};

export default RequireLogin;
